import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DesktopNav from './DesktopNav';
import { useAppSettings } from '../../context/AppSettingsContext';

export default function Header({
  title, showBack = false, showLogo = false,
  showQR = false, showNotif = false, isDoctor = false,
  onMenuClick, onQRClick, onNotifClick,
  notifCount = 0, rightElement,
}) {
  const navigate  = useNavigate();
  const settings  = useAppSettings();
  // useAuth available if needed for future patient-specific header features
  const [imgFailed, setImgFailed] = useState(false);

  const logoSrc = (!imgFailed && settings.appLogo) ? settings.appLogo : '/logo-header.png';
  const appName = settings.appName || 'Faristaa';

  return (
    <header className="fixed top-0 left-0 right-0 z-30 h-14 bg-white border-b border-border flex items-center px-3 shadow-sm">

      {/* ── LEFT: Hamburger or Back ─────────────────────────── */}
      <div className="flex items-center w-12 flex-shrink-0">
        {showBack ? (
          <button onClick={() => navigate(-1)} className="w-10 h-10 flex items-center justify-center rounded-xl active:bg-surface">
            <i className="fa-solid fa-arrow-left text-text-primary text-lg" />
          </button>
        ) : onMenuClick ? (
          /* Bigger hamburger icon */
          <button onClick={onMenuClick}
            className="w-11 h-11 flex items-center justify-center rounded-xl active:bg-surface transition-colors">
            <i className="fa-solid fa-bars text-text-primary text-xl" />
          </button>
        ) : null}
      </div>

      {/* ── CENTER: Logo or Title ───────────────────────────── */}
      <div className="flex-1 flex items-center justify-center min-w-0">
        {showLogo ? (
          <>
            {/* Logo centered on mobile */}
            <div className="flex items-center justify-center">
              <img
                src={logoSrc}
                alt={appName}
                className="h-7 w-auto object-contain max-w-[160px]"
                onError={() => setImgFailed(true)}
              />
            </div>
            {/* Desktop nav shown inline after logo on md+ */}
            {!isDoctor && (
              <div className="hidden md:flex ml-6">
                <DesktopNav />
              </div>
            )}
          </>
        ) : (
          <span className="text-base font-semibold text-text-primary font-heading truncate">
            {title}
          </span>
        )}
      </div>

      {/* ── RIGHT: Notif + QR + custom ─────────────────────── */}
      <div className="flex items-center gap-1 flex-shrink-0 w-12 justify-end">

        {/* Notification bell */}
        {showNotif && (
          <button onClick={onNotifClick} className="w-10 h-10 flex items-center justify-center rounded-xl active:bg-surface relative">
            <i className="fa-solid fa-bell text-text-primary text-lg" />
            {notifCount > 0 && (
              <span className="absolute top-1 right-1 w-4 h-4 bg-danger text-white text-[9px] font-bold rounded-full flex items-center justify-center">
                {notifCount > 9 ? '9+' : notifCount}
              </span>
            )}
          </button>
        )}

        {/* QR / custom element */}
        {showQR && !rightElement && (
          <button onClick={onQRClick} className="w-10 h-10 flex items-center justify-center rounded-xl active:bg-surface">
            <i className="fa-solid fa-qrcode text-text-primary text-lg" />
          </button>
        )}
        {rightElement}
      </div>
    </header>
  );
}
